import type { SVGProps } from 'react';

const SvgSelectionText = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M10 15V6h3v.5c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1s1-.45 1-1V6h3v9h-.5c-.55 0-1 .45-1 1s.45 1 1 1H10c.55 0 1-.45 1-1s-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="m20.6 13.08-7.84-1.57a.502.502 0 0 0-.59.59l1.57 7.84c.09.47.72.55.94.13l1.35-2.7 1.65 1.65c.2.2.51.2.71 0l1.29-1.29c.2-.2.2-.51 0-.71l-1.65-1.65 2.7-1.35c.43-.21.34-.84-.13-.94"
    />
  </svg>
);
export default SvgSelectionText;
